export const OPEN_MODAL = 'checkout/OPEN_MODAL';
export const openModal = () => ({
    type: OPEN_MODAL,
});

export const CLOSE_MODAL = 'checkout/CLOSE_MODAL';
export const closeModal = () => ({
    type: CLOSE_MODAL,
});



// WEBPACK FOOTER //
// ./resources/components/shop/actions/modal.js